import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "@/i18n";
import { SiteSettingsProvider } from "@/SiteSettings";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import VacationBanner from "@/components/VacationBanner";
import Home from "@/pages/Home";
import MenuPage from "@/pages/MenuPage";
import EventsPage from "@/pages/EventsPage";
import VouchersPage from "@/pages/VouchersPage";
import VoucherSuccess from "@/pages/VoucherSuccess";
import { ImpressumPage, DatenschutzPage } from "@/pages/LegalPages";
import AdminPage from "@/pages/AdminPage";

function Layout({ children }) {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <VacationBanner />}
      {!isAdmin && <Navbar />}
      <main>{children}</main>
      {!isAdmin && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <SiteSettingsProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/speisekarte" element={<MenuPage />} />
              <Route path="/veranstaltungen" element={<EventsPage />} />
              <Route path="/gutscheine" element={<VouchersPage />} />
              <Route path="/gutschein/erfolg" element={<VoucherSuccess />} />
              <Route path="/impressum" element={<ImpressumPage />} />
              <Route path="/datenschutz" element={<DatenschutzPage />} />
              <Route path="/admin" element={<AdminPage />} />
            </Routes>
          </Layout>
        </BrowserRouter>
        </SiteSettingsProvider>
        <Toaster position="top-center" richColors />
      </LanguageProvider>
    </div>
  );
}

export default App;
